module.exports = "#ifdef USE_FOG\n\n  varying float fogDepth;\n\n#endif\n"